<template>
  <div>
    <!-- Loading skeleton -->
    <div v-if="loading">
      <b-card>
        <b-skeleton width="40%" height="2rem" class="mb-2"/>
        <b-skeleton width="70%" class="mb-1"/>
        <b-skeleton width="55%" class="mb-1"/>
        <b-skeleton-table :rows="5" :columns="4" hide-header/>
      </b-card>
    </div>

    <template v-else>
      <!-- Profit Cards -->
      <b-row>
        <b-col md="6">
          <b-card class="text-center border-left-3"
            :class="profitToday >= 0 ? 'border-success' : 'border-danger'">
            <h6 class="text-muted">Profit if Sold TODAY</h6>
            <h1 :class="profitToday >= 0 ? 'text-success' : 'text-danger'" class="display-4 font-weight-bold">
              ₹{{ formatNumber(profitToday) }}
            </h1>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card class="text-center"
            :class="profitIn7Days >= 0 ? 'border-success' : 'border-danger'">
            <h6 class="text-muted">Projected Profit in 7 Days</h6>
            <h1 :class="profitIn7Days >= 0 ? 'text-success' : 'text-danger'" class="display-4 font-weight-bold">
              ₹{{ formatNumber(profitIn7Days) }}
            </h1>
          </b-card>
        </b-col>
      </b-row>

      <!-- Market Price Info -->
      <b-card>
        <b-row>
          <b-col>
            <span class="text-muted">Market Price Used: </span>
            <strong>₹{{ prediction.market_price_per_kg || '—' }} / kg</strong>
          </b-col>
          <b-col class="text-right">
            <b-button variant="outline-primary" size="sm" @click="fetchData">Refresh</b-button>
          </b-col>
        </b-row>
      </b-card>

      <!-- Cost Breakdown Table -->
      <b-card title="Cost Breakdown">
        <b-table :items="costBreakdown" :fields="costFields" striped hover responsive>
          <template #cell(amount)="data">
            <span>₹{{ formatNumber(data.value) }}</span>
          </template>
        </b-table>
      </b-card>
    </template>
  </div>
</template>

<script>
import axios from '@/libs/axios'
import { BSpinner, BCard, BRow, BCol, BTable, BButton } from 'bootstrap-vue'

export default {
  name: 'ProfitPredictor',
  components: { BSpinner, BCard, BRow, BCol, BTable, BButton },
  data() {
    return {
      loading: false,
      prediction: {},
      costFields: [
        { key: 'label', label: 'Cost Item' },
        { key: 'amount', label: 'Amount (₹)' },
      ],
    }
  },
  computed: {
    profitToday() {
      return parseFloat(this.prediction.profit_today) || 0
    },
    profitIn7Days() {
      return parseFloat(this.prediction.projected_profit_7_days) || 0
    },
    costBreakdown() {
      if (!this.prediction.cost_breakdown) return []
      const cb = this.prediction.cost_breakdown
      return [
        { label: 'Chick Cost', amount: cb.chick_cost || 0 },
        { label: 'Feed Cost', amount: cb.feed_cost || 0 },
        { label: 'Medicine', amount: cb.medicine_cost || 0 },
        { label: 'Vaccine', amount: cb.vaccine_cost || 0 },
        { label: 'Other Expenses', amount: cb.other_expenses || 0 },
        { label: 'Total Cost', amount: cb.total_cost || 0 },
      ]
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const { farmId, shedId, flockId } = this.$route.params
      this.loading = true
      try {
        const { data } = await axios.get(`web/farms/${farmId}/sheds/${shedId}/flocks/${flockId}/profit-predict`)
        this.prediction = data
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('Failed to load profit prediction', { variant: 'danger', title: 'Error' })
      } finally {
        this.loading = false
      }
    },
    formatNumber(val) {
      return Number(val || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
  },
}
</script>

<style scoped>
.display-4 { font-size: 2.5rem; }
.border-left-3 { border-left: 4px solid; }
</style>
